import _memoize from 'lodash/memoize';

let NumberFormat;

if (typeof window !== 'undefined') {
  NumberFormat = Intl.NumberFormat;
} else {
  NumberFormat = require('intl').NumberFormat;
}

const cacheKeyResolver = (lang, options) =>
  `${lang}${JSON.stringify(options, Object.keys(options).sort())}`;

const getFormatter = _memoize((lang, options) => new NumberFormat(lang, options), cacheKeyResolver);

const currenciesInfo = {
  UAH: {
    symbol: '₴',
    numberFormatOptions: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  KZT: {
    symbol: '‎₸',
    numberFormatOptions: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  GBP: {
    symbol: '£',
    numberFormatOptions: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
  USD: {
    symbol: '$',
    numberFormatOptions: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  EUR: {
    symbol: '€',
    numberFormatOptions: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
  TRY: {
    symbol: '‎₺',
    numberFormatOptions: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  PLN: {
    symbol: 'zł',
    numberFormatOptions: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  RUB: {
    symbol: '₽',
    numberFormatOptions: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  BYN: {
    symbol: 'Br',
    numberFormatOptions: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
  CHF: {
    symbol: 'CHF',
    numberFormatOptions: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
};

const defaultOptions = {
  currencyCode: '',
  lang: 'ru',
  numberFormatOptions: {},
  useSymbol: true,
  asNumber: false, // false: "$123.45", true: "123.45"
};

const formatMoney = (amount, options = {}) => {
  // eslint-disable-next-line no-param-reassign
  options = {
    ...defaultOptions,
    ...options,
  };

  const {
    currencyCode: optionsCurrencyCode,
    lang,
    numberFormatOptions: customNumberFormatOptions,
    useSymbol,
    asNumber,
  } = options;

  const currencyCode = optionsCurrencyCode.toUpperCase();

  const currencyInfo = currenciesInfo[currencyCode];

  // костыль для обратной совместимости
  const overallAsNumber = asNumber || !useSymbol;

  if (!currencyInfo) {
    return `${amount} ${currencyCode}`;
  }

  let result;

  try {
    const formatter = getFormatter(lang, {
      currency: currencyCode,
      ...currencyInfo.numberFormatOptions,
      ...customNumberFormatOptions,
      style: overallAsNumber ? 'decimal' : 'currency',
    });
    result = formatter.format(amount);
  } catch (ex) {
    result = `${amount}${overallAsNumber ? '' : ` ${currencyInfo.symbol}`}`;
  }

  if (useSymbol) {
    result = result.replace(currencyCode, currencyInfo.symbol);
  }

  return result;
};

export default formatMoney;

export { currenciesInfo };
